function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchBold = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 22,
  overflow: "visible",
  preserveAspectRatio: "none",
  viewBox: "0 0 21 22"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.845 13.8c.764-1.4 1.337-3 1.337-4.8 0-5-3.818-9-8.591-9S0 4 0 9s3.818 9 8.59 9c1.72 0 3.246-.6 4.583-1.4l5.154 5.4L21 19.2zm-7.254.2c-2.673 0-4.773-2.2-4.773-5s2.1-5 4.773-5 4.773 2.2 4.773 5-2.1 5-4.773 5",
  style: {
    strokeWidth: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fill: "#007c76"
  },
  vectorEffect: "non-scaling-stroke"
}));
export default SvgSearchBold;